import { Component } from '@theme/component';

class EqPdpSharing extends Component {
  requiredRefs = ['copyButton', 'status'];

  async copyLink() {
    const url = this.refs.copyButton?.dataset.url;
    if (!url) return;

    try {
      await navigator.clipboard.writeText(url);
    } catch {
      const input = document.createElement('textarea');
      input.value = url;
      input.setAttribute('readonly', '');
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      input.remove();
    }

    if (this.refs.status) {
      this.refs.status.textContent = this.dataset.copySuccess ?? '';
      window.setTimeout(() => {
        if (this.refs.status) this.refs.status.textContent = '';
      }, 2500);
    }
  }
}

if (!customElements.get('eq-pdp-sharing')) {
  customElements.define('eq-pdp-sharing', EqPdpSharing);
}
